import { AxiosInstance, AxiosResponse } from "axios";
import {
  AuthenticationResponseType,
  AuthenticationType
} from "../entities/Authentication";

export class AuthResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async authentication(
    payload: AuthenticationType
  ): Promise<AxiosResponse<AuthenticationResponseType>> {
    return this.apiProvider.post<AuthenticationResponseType>(
      "/token",
      {
        grant_type: "password",
        ...payload
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );
  }
}
